import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { getSocietyValue } from 'utils/getSocietyValue';

export const useGetSocietyValue = () => {
  const [societyValue, setSocietyValue] = useState<number>(0);

  const society = useSelector((state: State) => state.society?.actualSociety);

  useEffect(() => {
    if (society) {
      const societyValue = getSocietyValue(society);
      setSocietyValue(societyValue);
    } else {
      setSocietyValue(0);
    }
  }, [society]);

  return {
    data: { societyValue },
  };
};
